import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Send, Loader2, CheckCircle2 } from "lucide-react";
import api from "../lib/api";
import Logo from "../components/Logo";

export default function PulseShare() {
  const { token } = useParams();
  const [pulse, setPulse] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);

  useEffect(() => {
    api.get(`/pulse-share/${token}`).then(({ data }) => setPulse(data))
      .catch((e) => setErr(e.response?.data?.detail || "Share link not found"));
  }, [token]);

  const send = async () => {
    setBusy(true); setErr("");
    try { const { data } = await api.post(`/pulse-share/${token}`); setDone(data.recipients); }
    catch (e) { setErr(e.response?.data?.detail || "Couldn't share"); }
    finally { setBusy(false); }
  };

  const shared = done !== null || pulse?.shared_at;
  return (
    <div className="min-h-screen bg-white p-6 sm:p-12">
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center gap-2 mb-10"><Logo size={32} /><div className="text-lg font-black tracking-tighter">VIZIONCAST</div></div>
        {!pulse && !err && <Loader2 className="w-6 h-6 animate-spin text-[#0033FF]" data-testid="pulse-share-loading" />}
        {!pulse && err && <div data-testid="pulse-share-error" className="text-sm text-[#FF3B30]">{err}</div>}
        {pulse && (
          <>
            <div className="text-xs tracking-[0.25em] uppercase text-[#FF3B30] font-bold mb-3">{pulse.title}</div>
            <h1 className="text-3xl sm:text-4xl font-black tracking-tighter mb-6">Share your pulse with the team.</h1>
            <div className="border-l-4 border-[#FF3B30] pl-5 text-sm leading-relaxed whitespace-pre-wrap text-zinc-700 mb-8" data-testid="pulse-share-body">{pulse.body}</div>
            {shared ? (
              <div className="flex items-center gap-2 text-sm font-bold text-[#0033FF]" data-testid="pulse-share-done">
                <CheckCircle2 className="w-5 h-5" /> Shared with {done ?? pulse.shared_with} teammate{(done ?? pulse.shared_with) === 1 ? "" : "s"}.
              </div>
            ) : (
              <button onClick={send} disabled={busy || !pulse.recipients} data-testid="pulse-share-send-btn"
                className="bg-[#0033FF] text-white px-6 py-3.5 text-sm font-bold uppercase tracking-wider hover:bg-zinc-900 disabled:opacity-40 inline-flex items-center gap-2">
                {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
                Send to {pulse.recipients} teammate{pulse.recipients === 1 ? "" : "s"}
              </button>
            )}
            {!pulse.recipients && !shared && <p className="text-xs text-zinc-500 mt-3">Add seats or team members with emails in VizionCast first.</p>}
            {err && <div data-testid="pulse-share-send-error" className="text-sm text-[#FF3B30] mt-4">{err}</div>}
          </>
        )}
      </div>
    </div>
  );
}
